import { waiverContants } from '../../_constants';

export function waiver(state = {}, action) {
    switch (action.type) {
        case waiverContants.RESET:
            return {}
        case waiverContants.WAIVER_FETCHING:
            return {
                ...state,
                waiverFetching: true,
            };
        case waiverContants.WAIVER_FETCHED:
            return {
                ...state,
                waiverFetching: false,
            };
        case waiverContants.WAIVER_SUBMITTING:
            return {
                ...state,
                waiversSubmitting: true,
            };
        case waiverContants.WAIVER_SUBMITTED:
            return {
                ...state,
                waiversSubmitting: false,
            };
        case waiverContants.SEARCH_BOOKING_WAYBILL:
            return {
                ...state,
                BWData: action.BWData,
            };
        case waiverContants.GET_WAIVERED_LIST:
            return {
                ...state,
                waiverList: action.waiverList,
            };
        case waiverContants.GET_WAIVER_BY_ID:
            return {
                ...state,
                waiverById: action.waiverById,
            };
        case waiverContants.GET_WAIVERED_ENDORSER_LIST:
        return {
            ...state,
            waiverList: action.waiverList,
        };
        default:
            return state;
    }
}